var TRANSITION = {
  DURATION_MS: 250,
  TIMING_FUNCTION: "cubic-bezier(0.22, 1, 0.36, 1)"
};
export default TRANSITION;